<!--Popup Header -->
<div class="d-flex popup-head align-items-center">
    <div class="popup-title mr-auto" translate>{{heading}}</div>
    <div class="float-right">
      <a class="close mr-2" (click)="OnClose()" translate>
        <span aria-hidden="true">&times;</span>
      </a>
    </div>
  </div>
  
  <!-- Body Header-->
  <div class="subheader with-padding flgrow">
    <div class="row align-items-center">
      <!-- Multiselect Dealer Dropdown -->
      <div class="col-lg-6 col-md-6 col-sm-6">
        <div class="input-group">
          <input
          class="form-control"
          type="text"
          [(ngModel)]="agentName"
          disabled
        />
        </div>
      </div>
  
      <!-- Date Range Picker -->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class="date">
          <input
            class="form-control"
            type="text"
            [(ngModel)]="selectedDate"
            disabled
          />
        </div>
      </div>

      <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
        <!-- Excel -->
        <button type="button" (click)="exportAsXLSX()" 
            ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align"  style="margin-right: 10px;">
            <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
        </button>
        <!-- PDF -->
        <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
            ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
            <em class="far fa-file fa-2x"></em>
            <span class="bdg">PDF</span>
        </button>
    </div>
    </div>
  </div>
  
  <div class="scrollbar user">
    <div class="row">
      <div class="c12">
        <div class="card">
          <!-- Body Header -->
          <div class="card-header d-flex justify-content-between mx-2" translate>
            {{title}}
            <div class="font16 fontbold">
              <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
              {{ totalCount }}
              &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
            </div>
          </div>
  
          <!-- Body Content -->
          <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false" (scrolled)="loadMoreData($event)">
            <table class="tablest1">
              <thead *ngIf = "entityType == 'Appointment'">
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" translate>lblRegNumber</th>
                  <th scope="col" translate>lblWoNo</th>
                  <th scope="col" translate>lblBookedDate</th>
                  <th scope="col" translate>lblWorkOrderStatus</th>
                  <th scope="col" translate>lblAction</th>
                </tr>
              </thead>
  
              <tbody *ngIf = "entityType == 'Appointment'">
                <ng-container
                  *ngIf="
                  agentDetailsList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of agentDetailsList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <div class="flmid">
                          <div class="licplate LPNo d-flex">
                              <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                              {{item.licensePlate}}
                          </div>
                          <div class="imgWid">
                              <ng-container *ngIf="item.brandCode">
                                  <img af-brand-logo [data-code]="item.brandCode" data-type="BRAND"
                                      class="{{item.brandCode}}-icon common"
                                      [title]="item.brandCode" class="brandicon" alt="img" />
                              </ng-container>
                          </div>
                      </div>
                      <div class="mt-1">
                          <ngb-highlight class="flmid semibold fs-12px lh-16px"
                              [result]="item.modelName">
                          </ngb-highlight>
                      </div>
                  </td>
                    <td>
                      <ngb-highlight [result]="item.workOrderNo"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.bookedDate | date : 'short'">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.workOrderStatus"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.action"> </ngb-highlight>
                    </td>
                  </tr>
                </ng-container>
  
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
              <thead *ngIf = "entityType == 'Customer'">
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" translate>lblCustomerNumber</th>
                  <th scope="col" translate>lblCustomerName</th>
                  <th scope="col" translate>lblCustomerPhone</th>
                  <th scope="col" translate>lblCustomerEmail</th>
                  <th scope="col" translate>lblAction</th>
                </tr>
              </thead>
  
              <tbody *ngIf = "entityType == 'Customer'">
                <ng-container
                  *ngIf="
                  agentDetailsList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of agentDetailsList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <ngb-highlight [result]="item.customerNo"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.customerName"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.customerPhone"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.customerEmail"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.action"> </ngb-highlight>
                    </td>
                  </tr>
                </ng-container>
  
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>

              <thead *ngIf = "entityType == 'Vehicle'">
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th scope="col" translate>lblRegNumber</th>
                  <th scope="col" translate>lblVinNumber</th>
                  <th scope="col" translate>lblVehicleGroup</th>
                  <th scope="col" translate>lblVehicleType</th>
                  <th scope="col" translate>lblFuelType</th>
                  <th scope="col" translate>lblAction</th>
                </tr>
              </thead>
  
              <tbody *ngIf = "entityType == 'Vehicle'">
                <ng-container
                  *ngIf="
                  agentDetailsList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of agentDetailsList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <div class="flmid">
                          <div class="licplate LPNo d-flex">
                              <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                              {{item.licensePlate}}
                          </div>
                          <div class="imgWid">
                                <img af-brand-logo [data-code]="item.brandCode" data-type="BRAND"
                                    class="{{item.brandCode}}-icon common"
                                    [title]="item.brandCode" class="brandicon" alt="img" />
                          </div>
                      </div>
                      <div class="mt-1">
                          <ngb-highlight class="flmid semibold fs-12px lh-16px"
                              [result]="item.modelName">
                          </ngb-highlight>
                      </div>
                  </td>
                    <td>
                      <ngb-highlight [result]="item.chassisNo"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.vehicleGroup"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.vehicleType"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.fuelType"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.action"> </ngb-highlight>
                    </td>
                  </tr>
                </ng-container>
  
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>

              <thead *ngIf = "entityType == 'Call'">
                <tr>
                  <th style="width: 10%" scope="col">#</th>
                  <th style="width: 20%;" scope="col" translate>lblCustomerName</th>
                  <th style="width: 15%;" scope="col" translate>lblCallFromNo</th>
                  <th style="width: 15%; " scope="col" translate class="text-center">lblTotalCallDuration</th>
                  <th style="width: 20%; " scope="col" translate class="text-center" >lblStartTime</th>
                  <th style="width: 20%; " scope="col" translate class="text-center">lblEndTime</th>
                </tr>
              </thead>
  
              <tbody *ngIf = "entityType == 'Call'">
                <ng-container
                  *ngIf="
                  agentDetailsList?.length > 0;
                    else load_NotFound_Template
                  "
                >
                  <tr *ngFor="let item of agentDetailsList; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <ngb-highlight [result]="item.customerName"> </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="item.callFromNo"> </ngb-highlight>
                    </td>
                    <td class="text-center">
                      <ngb-highlight  [result]="item.duration"></ngb-highlight>
                    </td>
                    <td class="text-center">
                      <ngb-highlight  [result]="item.callStartTime"></ngb-highlight>
                    </td>
                    <td class="text-center" >
                      <ngb-highlight  [result]="item.callEndTime"></ngb-highlight>
                    </td>
                  </tr>
                </ng-container>
  
                <ng-template #load_NotFound_Template>
                  <tr>
                    <td colspan="8" class="no-record" translate>
                      lblNoRecordsFound
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Footer -->
  <div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
        <a
          (click)="OnClose()"
          type="reset"
          class="btn btn-secondary btn-lg"
          translate
          ><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a
        >
      </div>
    </div>
  </div>
  